import {http} from '../plugins/http'

import {has,get,isEmpty} from 'lodash-es'

import store from 'store2'
const persist = store.namespace('auth')

export const auth = {
  namespaced: true,
  state: {
    token: persist.get('token'),
    user: persist.get('user')
  },
  mutations: {
    authenticate(state, {user, token}) {
      state.user = user
      state.token = token
      persist.setAll({user, token})
    },
    logout (state) {
      state.user = undefined
      state.token = undefined
      persist.remove('user')
      persist.remove('token')
    }
  },
  actions: {
    authenticate({commit}, data) {
      if ( has(data,'user') && has(data, 'token') )
        commit('authenticate', data)
    },
    logout ({commit}) {
      commit('logout')
    }
  },
  getters: {
    isLoggedIn: state => !isEmpty(state.user) && !isEmpty(state.token),
    user: state => state.user,
    token: state => state.token
  }
}
